import { toastError, toastSuccess } from "../guest-slices/other.slice"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { BASEURI, headers } from "../../utils/helper"
import { Cookies } from "react-cookie"
import axios from "axios"

const cookies = new Cookies()

// Handle forgot password
export const forgotPasswordReq = createAsyncThunk("forgotPasswordReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/admin/auth/forgot-password`, data)

    if (response.data?.success) {
      dispatch(toastSuccess(response.data?.message))
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(toastError(newErr))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(toastError(newErr))
    return rejectWithValue(error)
  }
})

// Handle user login
export const userLoginReq = createAsyncThunk("userLoginReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/admin/auth/login`, data, { withCredentials: true })

    if (response.data?.success) {
      if (response.data.token) {
        cookies.set("token", response.data.token, { path: "/" })
        window.location.replace("/dashboard")
      }
      dispatch(toastSuccess(response.data?.message))
      return response.data?.user
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(toastError(newErr))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(toastError(newErr))
    return rejectWithValue(error)
  }
})

// Get Admin Profile
export const getAdminProfileReq = createAsyncThunk("getAdminProfileReq", async (_, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.get(`${BASEURI}/admin/auth/profile`, { headers: headers() })

    if (response.data?.success) {
      return response.data?.user
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(toastError(newErr))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(toastError(newErr))
    return rejectWithValue(error)
  }
})

// Update Admin Profile
export const updateAdminProfileReq = createAsyncThunk("updateAdminProfileReq", async (formData, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/admin/auth/update-profile`, formData, {
      headers: {
        ...headers(),
        "Content-Type": "multipart/form-data"
      }
    })

    if (response.data?.success) {
      dispatch(toastSuccess(response.data?.message || "Profile updated successfully!"))
      return response.data?.user
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(toastError(newErr))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(toastError(newErr))
    return rejectWithValue(error)
  }
})

// Update Admin Password
export const updateAdminPasswordReq = createAsyncThunk("updateAdminPasswordReq", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await axios.post(`${BASEURI}/admin/auth/update-password`, data, { headers: headers() })

    if (response.data?.success) {
      dispatch(toastSuccess(response.data?.message || "Password updated successfully!"))
      return response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      dispatch(toastError(newErr))
    }

    return response
  } catch (error) {
    const newErr = error?.response?.data?.error || "Something went wrong!"
    dispatch(toastError(newErr))
    return rejectWithValue(error)
  }
})

const initialState = {
  user: {},
  other: {}
}
const auth = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    // Handle forgot password
    builder.addCase(forgotPasswordReq?.pending, (state) => {
      state.other.loadingLogin = true
    })
    builder.addCase(forgotPasswordReq?.fulfilled, (state) => {
      delete state?.other?.loadingLogin
    })
    builder.addCase(forgotPasswordReq?.rejected, (state) => {
      delete state?.other?.loadingLogin
    })

    // Handle user login
    builder.addCase(userLoginReq?.pending, (state) => {
      state.other.loadingLogin = true
    })
    builder.addCase(userLoginReq?.fulfilled, (state, { payload }) => {
      state.user = payload
      delete state?.other?.loadingLogin
    })
    builder.addCase(userLoginReq?.rejected, (state) => {
      delete state?.other?.loadingLogin
    })

    // Handle Get Profile
    builder.addCase(getAdminProfileReq?.fulfilled, (state, { payload }) => {
      state.user = payload
    })

    // Handle Update Profile
    builder.addCase(updateAdminProfileReq?.pending, (state) => {
      state.other.loadingProfile = true
    })
    builder.addCase(updateAdminProfileReq?.fulfilled, (state, { payload }) => {
      state.user = payload
      delete state?.other?.loadingProfile
    })
    builder.addCase(updateAdminProfileReq?.rejected, (state) => {
      delete state?.other?.loadingProfile
    })

    // Handle Update Password
    builder.addCase(updateAdminPasswordReq?.pending, (state) => {
      state.other.loadingPassword = true
    })
    builder.addCase(updateAdminPasswordReq?.fulfilled, (state) => {
      delete state?.other?.loadingPassword
    })
    builder.addCase(updateAdminPasswordReq?.rejected, (state) => {
      delete state?.other?.loadingPassword
    })

    // Logout
    builder.addCase("Logout", () => {
      cookies.remove("token", { path: "/" })
      window.location.replace("/login")
      return initialState
    })
  }
})

export default auth.reducer